import React from 'react';
import axios from 'axios';
import { CONFIRM_NOTIFY_JOB } from 'src/constants/EndpointUrls';
import { Close } from 'jbc-front/components/icons';
import Loading from 'src/components/Loading';
import { formatDateWithHour } from 'src/utils/Date';
import { NEW_LINE_CHARACTERS } from 'src/constants/Generals';
import styles from './NotifyJob.scss';
import { withTranslation } from 'react-i18next';

export default withTranslation()(class NotifyJob extends React.Component {
  state = {
    showJobInfo: true
  };
  confirmNotifyJob = () => {
    const { job } = this.props;
    if (job) {
      axios
        .post(CONFIRM_NOTIFY_JOB, { id: job.id, status: job.status })
        .then(() => {
          this.setState({ ...this.state, showJobInfo: false });
        })
        .catch(error => {
          console.log(error);
        });
    }
  };
  render() {
    const { job } = this.props;
    let wrapClass;
    if (job.status === 'waiting' || job.status === 'running') {
      wrapClass = styles.waitWrap;
    }
    if (job.status === 'success') {
      wrapClass = styles.successWrap;
    }
    if (job.status === 'failed') {
      wrapClass = styles.errorWrap;
    }
    if (!this.state.showJobInfo) {
      return null;
    }
    return (
      <div className={`${wrapClass}`}>
        {job.status === 'success' && (
          <React.Fragment>
            <div onClick={this.confirmNotifyJob} className={styles.close} role="presentation">
              <Close size={20} />
            </div>
            <div className={styles.inner}>
              <p className={styles.title}>{this.props.t('features.Employees.components.NotifyJob.employee_data_update_completed_with_CSV')}</p>
              <div className={styles.dates}>
                <dl>
                  <dt>{this.props.t('features.Employees.components.NotifyJob.upload_date')}</dt>
                  <dd>{formatDateWithHour(job.createdAt)}</dd>
                </dl>
                <dl>
                  <dt>{this.props.t('features.Employees.components.NotifyJob.completed_date')}</dt>
                  <dd>{formatDateWithHour(job.endAt)}</dd>
                </dl>
              </div>
            </div>
          </React.Fragment>
        )}
        {job.status === 'failed' && (
          <React.Fragment>
            <div onClick={this.confirmNotifyJob} className={styles.close} role="presentation">
              <Close size={20} />
            </div>
            <div className={styles.inner}>
              <p className={styles.title}>{this.props.t('features.Employees.components.NotifyJob.Error_occurred_during_employee_data_registration_with_CSV')}</p>
              <div className={styles.dates}>
                <dl>
                  <dt>{this.props.t('features.Employees.components.NotifyJob.upload_date')}</dt>
                  <dd>{formatDateWithHour(job.createdAt)}</dd>
                </dl>
                <dl>
                  <dt>{this.props.t('features.Employees.components.NotifyJob.error_date')}</dt>
                  <dd>{formatDateWithHour(job.endAt)}</dd>
                </dl>
              </div>
              <ul className={styles.list}>
                {_.split(job.performErrors, NEW_LINE_CHARACTERS).map(error => <li key={error.id}>{error}</li>)}
              </ul>
            </div>
          </React.Fragment>
        )}
        {(job.status === 'waiting' || job.status === 'running') && (
          <div className={styles.inner}>
            <div className={styles.waiting}>
              <div className={styles.loading}>
                <Loading />
              </div>
              <div className={styles.info}>
                <p className={styles.title}>{this.props.t('features.Employees.components.NotifyJob.registering_employees_data_with_CSV')}</p>
                <p className="u-mt10">{this.props.t('features.Employees.components.NotifyJob.cannot_add_or_update_employee_information_during_registration_process')}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
})
